(function($, Drupal) {

  'use strict';

  /*----------------------------------------
   Stop preload animations
   https://css-tricks.com/transitions-only-after-page-load/
  ----------------------------------------*/
  Drupal.behaviors.removePreload = {
    attach: function (context, settings) {
      $(window, context).once('removePreload').on('load', function () {
        $('body').removeClass('preload');
      });
    }
  };

  /*----------------------------------------
   Example
  ----------------------------------------*/
  Drupal.behaviors.example = {
    attach: function(context, settings) {



    }
  };

  $("#trigger-menu").click(function(){
    $(this).toggleClass("expanded-menu");
    $(".hidden-nav").toggleClass("active-menu");
    $("body").toggleClass("no-scroll");
  });


  if ($('#edit-field-area-target-id').val() == 'All') {
      $('.form-item-field-message-products-target-id-3').addClass('show-me');
      $('body').addClass('all-selected');
  }
  if ($('#edit-field-area-target-id').val() == '32') {
      $('.form-item-field-message-products-target-id-1').addClass('show-me');
      $('body').addClass('ivascular-selected');
  }
  if ($('#edit-field-area-target-id').val() == '33') {
      $('.form-item-field-message-products-target-id').addClass('show-me');
      $('body').addClass('coronary-selected');
  }
  if ($('#edit-field-area-target-id').val() == '34') {
      $('.form-item-field-message-products-target-id-2').addClass('show-me');
      $('body').addClass('peripheral-selected');
  }

  $('#edit-field-area-target-id').change(function () {
    if ($(this).val() == 'All') {
        $('body').addClass('all-selected');
        $('.form-item-field-message-products-target-id-3').addClass('show-me');
        $('.form-item-field-message-products-target-id').removeClass('show-me');
        $('.form-item-field-message-products-target-id-1').removeClass('show-me');
        $('.form-item-field-message-products-target-id-2').removeClass('show-me');
    }
  });

  $('#edit-field-area-target-id').change(function () {
    if ($(this).val() == '32') {
        $('body').addClass('ivascular-selected');
        $('.form-item-field-message-products-target-id-1').addClass('show-me');
        $('.form-item-field-message-products-target-id').removeClass('show-me');
        $('.form-item-field-message-products-target-id-2').removeClass('show-me');
        $('.form-item-field-message-products-target-id-3').removeClass('show-me');
    }
  });

  $('#edit-field-area-target-id').change(function () {
    if ($(this).val() == '33') {
        $('body').addClass('coronary-selected');
        $('.form-item-field-message-products-target-id').addClass('show-me');
        $('.form-item-field-message-products-target-id-1').removeClass('show-me');
        $('.form-item-field-message-products-target-id-2').removeClass('show-me');
        $('.form-item-field-message-products-target-id-3').removeClass('show-me');
    }
  });

  $('#edit-field-area-target-id').change(function () {
    if ($(this).val() == '34') {
        $('body').addClass('peripheral-selected');
        $('.form-item-field-message-products-target-id-2').addClass('show-me');
        $('.form-item-field-message-products-target-id').removeClass('show-me');
        $('.form-item-field-message-products-target-id-1').removeClass('show-me');
        $('.form-item-field-message-products-target-id-3').removeClass('show-me');
    }
  });

  $( document ).ajaxComplete(function( event, request, settings ) {
    $('body').toggleClass('ajax-selected');
    if ($('#edit-field-area-target-id').val() == 'All') {
        $('.form-item-field-message-products-target-id-3').addClass('show-me');
    }
    if ($('#edit-field-area-target-id').val() == '32') {
        $('.form-item-field-message-products-target-id-1').addClass('show-me');
        $('body').addClass('ivascular-selected');
    }
    if ($('#edit-field-area-target-id').val() == '33') {
        $('.form-item-field-message-products-target-id').addClass('show-me');
        $('body').addClass('coronary-selected');
    }
  });

  $( ".chosen-results li:contains('-')" ).addClass('child-category');

})(jQuery, Drupal);
